let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_REQUEST": "Add Document",
    "LBL_VIEW_REQUEST": "View Document List",
    "LBL_CREATED_BY": "Created By",
    "LBL_DESCRIPTION":"Description",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_UPLOAD_BY":"Upload By",
    "LBL_UPLOAD_DOC":"Select File",
    "LBL_REQUEST_STATUS":"Upload Status",
    "LBL_EDIT_REQUESTS":"Edit Request",
    "LBL_DOCUMENT_REQUEST":"Request Document",
    "LBL_DOCUMENT_APPROVED":"Approved Document",
    "LBL_REQUEST_NO":"Request No",
    "LBL_DOCUMENT_TITLE":"Document Title",
    "LBL_MODULE_TITLE":"Institutional Docs",
    "LBL_MODULE_TITLE_DETAIL":"Details Institutional Docs",
    "LBL_UPLOADED_DOCUMENT":"Uploaded Document",
    "LBL_UPLOADED_BY":"Upload By",
    "LBL_DOCUMENT_SEQUENCE":"Document Sequence",
}

export default language;